/**
 * Card On File Status API Service
 *
 * GET /api/v2/student_profiles/{studentProfileId}/card_on_file_status?coach_id={coachExternalId}
 *
 * Returns whether the athlete has a saved card on file at the coach's
 * connected Stripe account. Used by the booking UI to decide whether to
 * offer "Charge card on file" as a payment method. Independent of the
 * facility-level booking options feature flag.
 */
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";

// Response keys are camelized by the scheduling fetch layer
// (successHandler → serialize → camelize), so what the BE serializes as
// `has_card_on_file` arrives here as `hasCardOnFile`.
export interface CardOnFileStatus {
  hasCardOnFile: boolean;
}

export async function getCardOnFileStatus(
  studentProfileId: string,
  coachExternalId?: string,
): Promise<boolean> {
  const response = await schedulingFetchGet<CardOnFileStatus>(
    `student_profiles/${studentProfileId}/card_on_file_status`,
    coachExternalId ? { coach_id: coachExternalId } : {},
  );

  return Boolean((response as CardOnFileStatus)?.hasCardOnFile);
}
